"use client";

import React from "react";
import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const pricingPlans = [{
  title: "Einzelplatz",
  price: "50€ / Tag · 250€ / Monat",
  description: "Ideal für alle, die nur mal für einen Tag produktiv sein wollen.",
  features: ["Platz für bis zu 8 Personen", "Highspeed WLAN inklusive", "Kaffee & Wasser Flatrate", "Zugang von 09:00 - 17:00 Uhr", "Nette Coworking-Community", "Nette Coworking-Community"],
  ctaText: "Tag buchen",
  ctaLink: "/PricesPage",
  isPopular: false
}, {
  title: "Einzelbüro",
  price: "100 € / Tag · 500 € / Monat",
  description: "Dein eigener Raum. Abschließbar. Für alles, was Ruhe und Privatsphäre braucht.",
  features: ["Freie Platzwahl im Space", "Parkplatz inlusive", "5h Meetingraum inklusive", "Kaffee & Wasser Flatrate", "Postadresse zubuchbar", "Community Events"],
  ctaText: "Büro anfragen",
  ctaLink: "/PricesPage",
  isPopular: true
}, {
  title: "Meetingraum",
  price: "40 € / Tag\n\n",
  description: "Präsentieren, besprechen, entscheiden. Unser Meetingraum mit großem Bildschirm, auch ohne Coworking-Vertrag buchbar.",
  features: ["Eigener fester Schreibtisch", "24/7 Zugang inklusive", "Kaffee, Tee,Wasser & Snack Flatrate", "Postadresse inklusive", "Privates Schließfach", "Kaffee & Wasser Flatrate"],
  ctaText: "Meetingraum anfragen",
  ctaLink: "/PricesPage",
  isPopular: false
}];
export default function Pricing() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll();
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}